import { render, staticRenderFns } from "./NewSputumCulture.vue?vue&type=template&id=830027f8&scoped=true"
import script from "./NewSputumCulture.vue?vue&type=script&lang=js"
export * from "./NewSputumCulture.vue?vue&type=script&lang=js"
import style0 from "./NewSputumCulture.vue?vue&type=style&index=0&id=830027f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830027f8",
  null
  
)

export default component.exports